import axios from "axios";

export default function AfficheArticleInMagasin(){
    const MagasinId = localStorage.getItem('MagasinId');  
    const urlShowArticle = `${process.env.REACT_APP_PHP_APP_URL}/magasins/stock`;
    const Url20article = `${process.env.REACT_APP_PHP_APP_URL}/topArticles`;

    const getArticle=()=>{
        return (axios.get(urlShowArticle));
    }
    const getArticleMagasin=(id:any)=>{
    const showArticle = `${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/stock`;

      return (axios.get(showArticle));
  }
    const getProductPagination = (page: number) => {
        return axios.get(urlShowArticle, {
          params: {
            page: page,
          },
        });
      };

const getAnly20Article = (page = 1, sort = '', disponible = false, magasinName = '', perPage = 20, seed?: number) => {
  const params: Record<string, string> = { page: String(page) };
  if (perPage) params['perPage'] = String(perPage);
  if (sort) params['sort'] = sort;
  if (disponible) params['disponible'] = '1';
  if (magasinName) params['magasinName'] = magasinName;
  if (seed !== undefined && seed !== null) params['seed'] = String(seed);
  return axios.get(Url20article, { params });
};
    return {
        getArticle,
        getArticleMagasin,
        getProductPagination,
        getAnly20Article
    }
}